import { connect } from "react-redux"
import React, { Component } from "react"

import type { Evidence, Role } from "../../types/types"
import { autocompleteTopicsAndDimensionsRequest } from "../../actions/autocomplete-actions"
import { getRoleOptions } from "../../config/util-functions"
import {
    roleApprove,
    roleEdit,
    roleReject,
    roleRemove
} from "../../actions/role-actions"
import EvidenceExpandableBlock from "./EvidenceExpandableBlock"
import SelectTags from "./tags/SelectTags"

type Props = {
    isFetching: boolean,
    evidence: Array<Evidence>,
    role: Role,
    stakeholderType: string,
    isExpanded: boolean,
    toggleEvidence: string => void,
    setRoleName: void => void,
    onApprove: Role => void,
    onReject: Role => void,
    onEditRole: Role => void,
    onRemoveRole: string => void,
    onTopicsAndDimensionsSearch: (
        searchTerm: string,
        callback: (void) => void
    ) => void
}

class StakeholderRelationshipEditRoleBlock extends Component<Props> {
    handleApprove = () => {
        this.props.onApprove(this.props.role)
    }

    handleReject = () => {
        this.props.onReject(this.props.role)
    }

    handleRemoveRole = () => {
        this.props.onRemoveRole(this.props.role.id)
    }

    handleEditRole = linkedNode => {
        this.props.onEditRole({
            ...this.props.role,
            linked_node: linkedNode
        })
    }

    handleEditRoleName = event => {
        this.props.onEditRole({
            ...this.props.role,
            name: event.target.value
        })
    }

    render() {
        const {
            role,
            isFetching,
            evidence,
            stakeholderType,
            isExpanded,
            toggleEvidence,
            onTopicsAndDimensionsSearch
        } = this.props

        const roleOptions = getRoleOptions(stakeholderType)

        return (
            <div className="stakeholder-role-edit-container">
                <div className="stakeholder-role-edit-block">
                    <select
                        name="role"
                        onChange={this.handleEditRoleName}
                        className="form-control stakeholder-role-select"
                        value={role.name}
                        required
                    >
                        {roleOptions.map(role => (
                            <option value={role} key={role}>
                                {role}
                            </option>
                        ))}
                    </select>
                    <div className="btn-group btn-moderate">
                        <button
                            className={
                                "btn btn-approve" +
                                (role.approved === true ? " active" : "")
                            }
                            onClick={this.handleApprove}
                            disabled={role.approved}
                        >
                            <i className="icon-hand-up" />
                        </button>
                        <button
                            className={
                                "btn btn-reject" +
                                (role.approved === false ? " active" : "")
                            }
                            onClick={this.handleReject}
                            disabled={!role.approved}
                        >
                            <i className="icon-hand-down" />
                        </button>
                    </div>
                    <span
                        className="icon-close-filters"
                        onClick={this.handleRemoveRole}
                    >
                        &times;
                    </span>
                    <div className="stakeholder-role-tags-container">
                        <SelectTags
                            name="area"
                            arrowRenderer={() => null}
                            disabled={false}
                            clearable={false}
                            multi={false}
                            value={role.linked_node}
                            valueKey="name"
                            placeholder="Type to search"
                            loadOptions={onTopicsAndDimensionsSearch}
                            onChange={this.handleEditRole}
                            onRemove={() => null}
                        />
                    </div>
                </div>
                <EvidenceExpandableBlock
                    roleId={role.id}
                    isFetching={isFetching}
                    evidence={evidence}
                    isExpanded={isExpanded}
                    toggleEvidence={toggleEvidence}
                />
            </div>
        )
    }
}

const mapStateToProps = ({ presentation }, { role }) => ({
    isFetching: presentation.evidence[role.id].isFetching,
    evidence: presentation.evidence[role.id].edit
})

const mapDispatchToProps = dispatch => ({
    onApprove: role => dispatch(roleApprove(role)),
    onReject: role => dispatch(roleReject(role)),
    onEditRole: role => dispatch(roleEdit(role)),
    onRemoveRole: roleID => dispatch(roleRemove(roleID)),
    onTopicsAndDimensionsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsAndDimensionsRequest(searchTerm, callback))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(
    StakeholderRelationshipEditRoleBlock
)
